module.exports = __webpack_public_path__ + "img/app_04.4b93fe38.jpg";